<template>
<div id="search_page" class="search-modal" role="dialog" aria-modal="true" aria-label="חיפוש">
  <!-- Backdrop -->
  <div class="search-modal__backdrop" @click="close_search()"></div>

  <!-- Panel -->
  <div class="search-modal__panel">

    <div class="search-modal__topbar">
      <button
        class="search-modal__close"
        type="button"
        aria-label="סגור חיפוש"
        @click="$emit('closesearch')"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>

      <router-link to="/" class="search-modal__logo" aria-label="דף הבית של Tov" @click.native="$emit('closesearch')"></router-link>
    </div>

    <!-- Search input -->
    <form class="search-modal__form" id="search_area" @submit.prevent="do_search()" method="get">
      <div class="search-modal__input-wrap" :class="{ 'search-modal__input-wrap--focused': inputFocused }">
        <span class="search-modal__input-icon" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </span>
        <input
          ref="search_inp"
          id="search_text"
          type="text"
          name="q"
          placeholder="חיפוש..."
          autocomplete="off"
          v-model="q_val"
          class="search-modal__input-native"
          dir="rtl"
          @keyup="do_search()"
          @focus="inputFocused = true"
          @blur="inputFocused = false"
        />
      </div>
      <input type="submit" style="display:none;">
    </form>

    <!-- Results area -->
    <div id="search_results" class="search-modal__results" @scroll="handleScroll">

      <!-- Sort chips -->
      <div v-if="items.length > 0" class="search-modal__sort-row">
        <button
          type="button"
          :class="['search-modal__sort-chip', sortBy === 'date' ? 'search-modal__sort-chip--active' : '']"
          @click="sortResults('date')"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          מיון לפי תאריך
          <svg v-if="sortBy === 'date'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
            <polyline v-if="sortDirection === 'asc'" points="18 15 12 9 6 15"/>
            <polyline v-else points="6 9 12 15 18 9"/>
          </svg>
        </button>
        <button
          type="button"
          :class="['search-modal__sort-chip', sortBy === 'name' ? 'search-modal__sort-chip--active' : '']"
          @click="sortResults('name')"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true">
            <polyline points="4 7 4 4 20 4 20 7"/>
            <line x1="9" y1="20" x2="15" y2="20"/>
            <line x1="12" y1="4" x2="12" y2="20"/>
          </svg>
          מיון לפי שם
          <svg v-if="sortBy === 'name'" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
            <polyline v-if="sortDirection === 'asc'" points="18 15 12 9 6 15"/>
            <polyline v-else points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </div>

      <!-- Results grid -->
      <div class="search-modal__grid">

        <!-- Empty state -->
        <div v-if="no_results" class="search-modal__empty">
          <div class="search-modal__empty-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
              <line x1="8" y1="11" x2="14" y2="11"/>
            </svg>
          </div>
          <p class="search-modal__empty-title">לא נמצאו תוצאות</p>
          <p class="search-modal__empty-body">נסה מילת חיפוש אחרת</p>
        </div>

        <!-- Result items -->
        <div
          v-for="item in sortedItems"
          :key="item.id"
          :data-blat="item.id"
          class="search-modal__grid-item"
        >
          <itemTpl :item="item" />
        </div>

        <!-- Loading more -->
        <div v-if="loading" class="search-modal__loading">
          <span class="search-modal__spinner" aria-hidden="true"></span>
          <span class="search-modal__loading-text">טוען תוצאות נוספות...</span>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import itemTpl from './item_tpl.vue'

export default {
  components: { itemTpl },
  props: ["search_promote"],
  data() {
    return {
      no_results: false,
      xhrsearch: null,
      q_val: '',
      page: 1,
      items: [],
      loading: false,
      hasMore: true,
      sortBy: 'date',
      sortDirection: 'desc',
      inputFocused: false,
    };
  },
  computed: {
    sortedItems() {
      if (!this.items.length) return [];

      const sorted = [...this.items];

      switch(this.sortBy) {
        case 'name':
          sorted.sort((a, b) => a.title.localeCompare(b.title, 'he-IL'));
          break;
        case 'date':
          sorted.sort((a, b) => new Date(b.date) - new Date(a.date));
          break;
        case 'views':
          sorted.sort((a, b) => (b.views || 0) - (a.views || 0));
          break;
      }

      return this.sortDirection === 'desc' ? sorted : sorted.reverse();
    }
  },
  methods: {
    sortResults(type) {
      if (this.sortBy === type) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = type;
        this.sortDirection = 'desc';
      }
    },
    close_search() {
      this.reset();
      this.$emit('closesearch');
    },
    reset() {
      this.q_val = '';
      this.page = 1;
      this.items = [];
      this.hasMore = true;
      this.sortBy = 'date';
      this.sortDirection = 'desc';
      var self = this;
      setTimeout(function(){ self.$refs["search_inp"].focus(); }, 100);
    },
    handleScroll(e) {
      const element = e.target;
      if (element.scrollHeight - element.scrollTop <= element.clientHeight + 100 && !this.loading && this.hasMore) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.loading || !this.hasMore) return;
      this.page++;
      this.do_search(true);
    },
    do_search(append = false) {
      if (!append) {
        this.page = 1;
        this.hasMore = true;
      }

      this.no_results = false;

      if (this.q_val.length === 0) {
        this.items = [];
        return;
      }

      this.loading = true;
      var self = this;

      this.$http.post(window.api_url + 'search/results', {
        limit: 20,
        q: this.q_val,
        page: this.page,
        api_user_token: localStorage.getItem('user_token')
      }, {
        before(request) {
          if (this.xhrsearch) {
            this.xhrsearch.abort();
          }
          this.xhrsearch = request;
        },
      }).then(function(data) {
        const newItems = data.data.data.items;
        if (!append) {
          self.items = newItems;
        } else {
          self.items = [...self.items, ...newItems];
        }

        self.hasMore = newItems.length === 20;
        self.loading = false;

        if (self.items.length === 0) {
          self.no_results = true;
        }
      }).catch(function() {
        self.loading = false;
      });
    }
  },
  watch: {
    $route() {
      this.close_search();
    }
  }
}
</script>

<style lang="scss">
/* ── Search Modal — token-aligned, RTL-safe ── */

.search-modal {
  position: fixed;
  inset: 0;
  z-index: 9000;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-family: var(--font-hebrew);
}

/* Backdrop */
.search-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(6px);
}

/* Close button — top-inline-end (right in RTL) */
.search-modal__close {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: rgba(0, 0, 0, 0.6);
  border: none;
  border-radius: 50%;
  color: var(--color-text);
  cursor: pointer;
  transition: background var(--duration-fast) var(--easing-default);

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
}

.search-modal__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 16px 4px;
  flex-shrink: 0;
}

.search-modal__logo {
  width: 96px;
  height: 34px;
  display: block;
  background: url('../assets/logo.png') no-repeat center center;
  background-size: contain;
}

/* Panel — full screen */
.search-modal__panel {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: var(--color-surface1);
  overflow: hidden;
}

/* Search form */
.search-modal__form {
  padding: var(--space-4) var(--space-6) var(--space-4);
  max-width: 640px;
  width: 100%;
  margin-inline: auto;
  flex-shrink: 0;
}

/* Input wrapper */
.search-modal__input-wrap {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 52px;
  padding-inline: var(--space-4);
  background: var(--color-surface2);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  transition: border-color var(--duration-fast) var(--easing-default),
              box-shadow var(--duration-fast) var(--easing-default);

  &.search-modal__input-wrap--focused {
    border-color: var(--color-text);
    box-shadow: none;
  }
}

.search-modal__input-icon {
  display: inline-flex;
  align-items: center;
  color: var(--color-textMuted);
  flex-shrink: 0;
}

.search-modal__input-native {
  flex: 1;
  min-width: 0;
  background: transparent;
  border: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  border-radius: 0;
  appearance: none;
  -webkit-appearance: none;
  color: var(--color-text);
  font-size: 18px;
  font-family: var(--font-hebrew);
  caret-color: var(--color-text);
  padding: 0;

  &::placeholder {
    color: var(--color-textDim);
  }

  &:focus,
  &:active {
    border: 0 !important;
    outline: none !important;
    box-shadow: none !important;
  }
}

/* Scrollable results */
.search-modal__results {
  flex: 1;
  overflow-y: auto;
  padding-block-end: var(--space-8);

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--color-surface4);
    border-radius: var(--radius-pill);
    &:hover {
      background: var(--color-borderHi);
    }
  }
}

/* Sort chip row */
.search-modal__sort-row {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  flex-wrap: wrap;
  max-width: 1300px;
  margin-inline: auto;
  padding: var(--space-4) var(--space-6);
}

.search-modal__sort-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: var(--radius-pill);
  border: 1px solid var(--color-border);
  background: transparent;
  color: var(--color-textMuted);
  font-size: 13px;
  font-weight: 500;
  font-family: var(--font-hebrew);
  cursor: pointer;
  transition: background var(--duration-fast) var(--easing-default),
              border-color var(--duration-fast) var(--easing-default),
              color var(--duration-fast) var(--easing-default);

  &:hover {
    background: var(--color-surface3);
    border-color: var(--color-borderHi);
    color: var(--color-text);
  }

  &.search-modal__sort-chip--active {
    background: var(--color-text);
    border-color: var(--color-text);
    color: #000;
  }

  &:focus-visible {
    outline: 2px solid var(--color-accent);
    outline-offset: 2px;
  }
}

/* Results grid — sized for 16:9 thumbs */
.search-modal__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: var(--space-5) var(--space-4);
  padding: var(--space-5) var(--space-6) var(--space-8);
  max-width: 1500px;
  margin-inline: auto;
  width: 100%;
  box-sizing: border-box;
}

.search-modal__grid-item {
  min-width: 0;
}
/* Override item_tpl rail-formula width so cards fill grid cell */
.search-modal__grid-item :deep(.poster-card__inner) {
  width: 100%;
  max-width: 80vw;
  min-width: 80vw;
  margin:0 auto
}

/* Empty state — spec §2.7 */
.search-modal__empty {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--space-12) var(--space-6);
  text-align: center;
}

.search-modal__empty-icon {
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-surface3);
  border-radius: var(--radius-md);
  color: var(--color-textMuted);
  margin-block-end: var(--space-6);
}

.search-modal__empty-title {
  margin: 0;
  margin-block-end: var(--space-2);
  font-size: 20px;
  font-weight: 700;
  color: var(--color-text);
  font-family: var(--font-hebrew);
}

.search-modal__empty-body {
  margin: 0;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: var(--color-textMuted);
  font-family: var(--font-hebrew);
}

/* Loading row */
.search-modal__loading {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-8);
}

.search-modal__loading-text {
  font-size: 14px;
  color: var(--color-textMuted);
  font-family: var(--font-hebrew);
}

/* Spinner */
.search-modal__spinner {
  display: block;
  width: 24px;
  height: 24px;
  border: 3px solid var(--color-surface4);
  border-radius: 50%;
  border-top-color: var(--color-accent);
  animation: search-spin 0.8s var(--easing-linear) infinite;
  flex-shrink: 0;
}

@keyframes search-spin {
  to { transform: rotate(360deg); }
}

/* Mobile */
@media (max-width: 768px) {
  .search-modal__topbar {
    padding: calc(env(safe-area-inset-top, 0px) + 8px) 10px 4px;
  }

  .search-modal__form {
    padding: 8px 10px 10px;
    max-width: none;
  }

  .search-modal__input-native {
    font-size: 16px;
  }

  .search-modal__grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: var(--space-4) var(--space-3);
    padding: var(--space-3) var(--space-4) var(--space-6);
  }

  .search-modal__sort-row {
    padding: var(--space-3) var(--space-4);
  }

  .search-modal__close {
    width: 40px;
    height: 40px;
    border: 1px solid var(--color-border);
    background: rgba(255,255,255,0.03);
  }
}

/* Reduced motion */
@media (prefers-reduced-motion: reduce) {
  .search-modal__spinner {
    animation: none;
    opacity: 0.5;
  }
  .search-modal__input-wrap,
  .search-modal__sort-chip,
  .search-modal__close {
    transition: none;
  }
}
</style>
